import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Forward.svg",
  "use": "Forward.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Forward.svg\"><path d=\"M35.2844,48.539a2.0033,2.0033,0,0,1-3.2852-1.5362V39.0209H12.01a2,2,0,0,1-2-2v-10a2,2,0,0,1,2-2H31.9992V17.006A2.0032,2.0032,0,0,1,35.2844,15.47L53.3112,30.4679a1.9979,1.9979,0,0,1,0,3.0725Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol